import { boolean, object, string } from 'yup'
import { CallResponse, ClubSupport } from './calls.types'

export const CallResponseSchema = object<CallResponse>().shape({
  callKey: string(),
  callId: string(),
  callDate: string(),
  servicingClub: string(),
  callStatus: string(),
  callToken: string(),
  updateToken: string(),
  trackToken: string(),
  pta: string(),
  ptaInLocalTime: string(),
})

export const ClubSupportSchema = object<ClubSupport>().shape({
  supported: boolean().required(),
})
